import { render } from "./VersionAddComponent.vue?vue&type=template&id=73f1bbbd&scoped=true"
import script from "./VersionAddComponent.vue?vue&type=script&lang=js"
export * from "./VersionAddComponent.vue?vue&type=script&lang=js"

import "./VersionAddComponent.vue?vue&type=style&index=0&id=73f1bbbd&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f1bbbd"]])

export default __exports__